module.exports = __webpack_public_path__ + "img/gray-assessment.6f205304.svg";